import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const ProjectsIntro = () => {
	const block = document.querySelector(".projects-intro");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollTrigger);
	const images = block.querySelectorAll(".projects-intro__images-el");
	const title = block.querySelector(".projects-intro__title");
	const text = block.querySelector(".projects-intro__text");
	const content = block.querySelector(".projects-intro__content");
	Splitting({ target: title, by: "chars" });
	const TLShow = gsap.timeline();
	
	TLShow.to(title.querySelectorAll(".char"), { y: "0%", opacity: 1, stagger: { each: 0.05 }, duration: 0.4 });
	TLShow.fromTo(text, { y: 100, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5 }, 0.2);

	TLShow.fromTo(images[0], { y: "100vh", opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.4);
	TLShow.fromTo(images[1], { y: "100vh", opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.4);
	TLShow.fromTo(images[2], { y: "100vh", opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.6);
	TLShow.fromTo(images[3], { y: "100vh", opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.5);

	TLShow.fromTo(images[4], { y: "100vh", opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.5);
	TLShow.fromTo(images[5], { y: "100vh", opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.6);
	TLShow.fromTo(images[6], { y: "100vh", opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.7);


	const TLScroll = gsap.timeline({
		scrollTrigger: {
			trigger: block,
			start: "top top",
			end: "+=200%",
			scrub: true
		}
	});
	TLScroll.fromTo(content, { y: 0 }, { y: "-30vh", duration: 3 }, 0);
	TLScroll.fromTo(images[0], { y: 0 }, { y: "-40vh", duration: 3 }, 0);
	TLScroll.fromTo(images[1], { y: 0 }, { y: "-50vh", duration: 2 }, 0); //
	TLScroll.fromTo(images[2], { y: 0 }, { y: "-60vh", duration: 3 }, 0);

	TLScroll.fromTo(images[3], { y: 0 }, { y: "-42vh", duration: 1 }, 0);
	TLScroll.fromTo(images[4], { y: 0 }, { y: "-50vh", duration: 3 }, 0);
	TLScroll.fromTo(images[5], { y: 0 }, { y: "-60vh", duration: 2 }, 0);
	TLScroll.fromTo(images[6], { y: 0 }, { y: "-40vh", duration: 4 }, 0);
};

export default ProjectsIntro;
